import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _CreditRoleGroup } from '../../../core/services/dataBean/EntityCatalogVdos';
import { PrintJson } from '../../theme/Component/PrintJson';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    filterUser?: "IsAnalist" | "IsCoordinate" | "IsReference"
}

export const SelectCreditRoleGroup = ({ idSelector, onChange, label, returnType = "ID", filterUser }: Props) => {
    const { instance, lista, setLista } = useDataBean(_CreditRoleGroup);
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDAccount == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    const getLista = () => {
    let props = { State: 1 };

    // if (filterUser) {
    //     props[filterUser] = true; 
    // }

        instance.getCreditRoleGroupCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                if(resp && filterUser)
                {
                    let temp = resp.filter(item => item.DataBeanProperties[filterUser] == true);
                    setLista(temp)
                }
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    return (
        <>
            <label>{label ?? "Seleccione Usuario"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDAccount} >{item.DataBeanProperties.AccountName}</option>
                        )
                    })
                }
            </select>
            {/* <PrintJson json={lista} /> */}
        </>
    )
}